import { createGlobalStyle } from 'styled-components'
import { desktop } from './designSystem/BreakPoints';


export const GlobalStyle = createGlobalStyle`

    html{
        color: #333;
        font-family: "Noto Sans", sans-serif;
        font-size: 16px;
        font-weight: 300;
        height: 100%;

        @media (min-width: ${desktop}px) {
            font-size: 16px;
        }
    }


    body{
        margin: 0;
        min-height: 100vh;
        height: 100%;
    }

    *, *:before, *:after{
        box-sizing: border-box;
    }

    #root{
        height: 100%;
    }

    body.modal-open-scroll {

        overflow: hidden;
        padding-right: 17px;
        
    }

    body.modal-open-no-scroll {
        overflow: hidden;
    }

    body.no-scroll {
        overflow: hidden;
    }

    body.loading-open-scroll {

        overflow: hidden;
        padding-right: 17px;
        
    }

    body.loading-open-no-scroll {
        overflow: hidden;
    }

    p {
        margin-top: 0px;
    }
`;